import ContentRowModal from './ContentRowModal.vue'

export default ContentRowModal
